/**
 * @generated SignedSource<<0db9aa287efacf2abf9cb6477e94b9c7>>
 * @relayHash 25c4e7e3a1a42f830c652c284c8c79d4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25c4e7e3a1a42f830c652c284c8c79d4

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Ch_updateProgressNotePointOfCareFromTimeWindowInput = {
  careProviderId?: string | null;
  dateFrom: any;
  dateTo: any;
  id: string;
};
export type useChUpdateProgressNoteFromTimeWindowMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_updateProgressNotePointOfCareFromTimeWindowInput;
};
export type useChUpdateProgressNoteFromTimeWindowMutation$data = {
  readonly ch_updateProgressNotePointOfCareFromTimeWindow: {
    readonly ch_ProgressNote: {
      readonly appointment: {
        readonly id: string;
        readonly language: Language;
      };
      readonly episodeOfCareId: string | null;
      readonly id: string;
      readonly pointOfCare: {
        readonly careProvider: {
          readonly id: string;
        } | null;
      } | null;
      readonly treatmentPlan: {
        readonly followUpInstructions: string | null;
        readonly from: any;
        readonly recommended: string | null;
        readonly title: string;
        readonly to: any;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChUpdateProgressNoteFromTimeWindowMutation = {
  response: useChUpdateProgressNoteFromTimeWindowMutation$data;
  variables: useChUpdateProgressNoteFromTimeWindowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ProgressNote",
  "kind": "LinkedField",
  "name": "ch_ProgressNote",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "episodeOfCareId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_PointOfCare",
      "kind": "LinkedField",
      "name": "pointOfCare",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CareProvider",
          "kind": "LinkedField",
          "name": "careProvider",
          "plural": false,
          "selections": [
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreatmentPlan",
      "kind": "LinkedField",
      "name": "treatmentPlan",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followUpInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommended",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "from",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProgressNoteNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChUpdateProgressNoteFromTimeWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_updateProgressNotePointOfCareFromTimeWindowPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNotePointOfCareFromTimeWindow",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useChUpdateProgressNoteFromTimeWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_updateProgressNotePointOfCareFromTimeWindowPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNotePointOfCareFromTimeWindow",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "ch_ProgressNote",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ch_ProgressNoteEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "25c4e7e3a1a42f830c652c284c8c79d4",
    "metadata": {},
    "name": "useChUpdateProgressNoteFromTimeWindowMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "57e063034dd610b8ddc0e461730c70a4";

export default node;
